export default "/images/vendor/@coreui/icons/svg/flag/cif-ir.svg?7a8df38112d67790d147f6b2a4b36ce0";